import { store } from "../store";

export const storeState = (payload) => async (dispatch) => {
    const state = await store.getState().products;
    dispatch({
        type: 'STATE',
        payload: {...state, ...payload}
    })
}